<template>
  <div>
    <v-expansion-panels dark>
      <v-expansion-panel
        :style="{
          'background-color': '#000000',
        }"
        :key="1"
      >
        <v-expansion-panel-header>
          <h6
            :style="{
              color: 'white',
            }"
          >
            Date, Comment & Discount
          </h6>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col :cols="6">
              <DatePickerWithMenu
                :dark="true"
                class="mb-n4"
                :default="todaysDate"
                :label="label"
                @date-selected="getSelectedDate"
              ></DatePickerWithMenu>
            </v-col>
            <v-col :cols="6">
              <vInputField
                class="mx-4 mt-4"
                :defaultValue="discountAmount"
                :label="'Discount(' + getCurrency + ')'"
                placeholder="Discount Amount"
                @input-updated="getDiscountAmount"
                :dark="true"
              ></vInputField>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <vTextArea
                label="Comment"
                hint="Comment goes here"
                class="mx-4 mt-n6"
                :defaultValue="content"
                @get-content="getCommentContent"
              >
              </vTextArea>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import vExpansionPanel from "@/components/Legos/vExpansionPanel.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import vInputField from "@/components/Legos/vInputField.vue";
import vTextArea from "@/components/Legos/vTextArea.vue";

export default {
  props: {
    label: {
      default: "Invoice Date",
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  components: {
    vExpansionPanel,
    DatePickerWithMenu,
    vInputField,
    vTextArea,
  },
  data: () => ({
    todaysDate: new Date().toISOString().substring(0, 10),
    discountAmount: 0,
    content: null,
  }),
  methods: {
    getSelectedDate(selectedDate) {
      this.todaysDate = selectedDate;
      this.$emit("date-selected", selectedDate);
    },
    getDiscountAmount(discountAmount) {
      this.discountAmount = discountAmount;
      this.$emit("get-discount-amount", discountAmount);
    },
    getCommentContent(content) {
      this.content = content;
      this.$emit("get-comment", content);
    },
  },
};
</script>

<style></style>
